import { Directive, AfterViewChecked, Input, ElementRef } from "@angular/core";

@Directive({
	selector: "[appModuleHeight]",
})
export class ModuleHeightDirective implements AfterViewChecked {
	@Input() appModuleHeight: string;
	@Input() open: boolean;

	constructor(private el: ElementRef) {}

	ngAfterViewChecked() {
		this.setHeight(this.el.nativeElement, this.open);
	}

	setHeight(parent: HTMLElement, opened: boolean) {
		if (!parent) {
			return;
		}

		if (opened) {
			parent.style.height = parent.children[0].scrollHeight + `px`;
		} else {
			parent.style.height = `0px`;
		}
	}
}
